import {BrowserModule} from '@angular/platform-browser';
import {ErrorHandler, NgModule} from '@angular/core';
import {AppComponent} from './app.component';
import {BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {HttpModule} from '@angular/http';
import {RouterModule} from '@angular/router';
import {ROUTES} from './app.routes';
import {PublicModule} from './modules/public/public.module';
import {ProtectedModule} from './modules/protected/protected.module';
import {HttpClientModule} from '@angular/common/http';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MaterialModule} from './modules/material/material.module';
import {PreviousUrlService} from './modules/form-renderer/services/previous-url/previous-url.service';
import {AuthService} from './modules/user/services/auth/auth.service';
import {CurrentUserService} from './modules/user/services/current-user/current-user.service';
import {SentryModule} from './modules/utilities/modules/sentry/sentry.module';

SentryModule.configure(); // configure sentry

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    HttpModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule.forRoot(ROUTES),
    // project modules
    MaterialModule,
    PublicModule,
    ProtectedModule,
    SentryModule.forRoot()
  ],
  exports: [
    RouterModule
  ],
  providers: [
    PreviousUrlService
  ],
  bootstrap: [
    AppComponent,
  ]
})
export class AppModule {
  constructor(public auth: AuthService, private currentUserService: CurrentUserService, private previousUrlService: PreviousUrlService) {
    auth.onLogin.subscribe(() => currentUserService.updateTimezoneOffset().subscribe());
    auth.handleAuthentication();
    auth.scheduleRenewal();
    this.previousUrlService.init();
  }
}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/app.module.ts